module.exports = __webpack_public_path__ + "./static/img/icon-1.8508d969aeb4dd4325de44abc09def29.png";


//////////////////
// WEBPACK FOOTER
// ./client/src/assets/img/company/icon-1.png
// module id = ./client/src/assets/img/company/icon-1.png
// module chunks = 0